import {$$} from '@vue-macros/reactivity-transform/macros'

import {
  IDatabasePropertyResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabasePropertyResponseInstance'
import {
  IAutoIdPropertyTypeInterfaces,
} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/AutoIdPropertyTypeStrategy/types/IAutoIdPropertyTypeInterfaces'
import {FilterItemType} from '@toolify/server/src/services/FilterService/enum/FilterItemType'
import {FilterGroupOperator} from '@toolify/server/src/services/FilterService/enum/FilterGroupOperator'
import {FilterPropertyOperator} from '@toolify/server/src/services/FilterService/enum/FilterPropertyOperator'
import {FilterPropertyPayloadType} from '@toolify/server/src/services/FilterService/enum/FilterPropertyPayloadType'
import {IFilter} from '@toolify/server/src/services/FilterService/types/IFilter'
import {DatabaseItemSortDirection} from '@toolify/server/src/services/DatabaseItemService/enum/DatabaseItemSortDirection'

export function useAutoIdValueTypeStrategy() {

  const fullValueToText = (value: IAutoIdPropertyTypeInterfaces['fullValue'], property: IDatabasePropertyResponseInstance<IAutoIdPropertyTypeInterfaces['options']>) => {
    const prefix = property?.options?.prefix || ''
    const suffix = property?.options?.suffix || ''
    return `${prefix}${value}${suffix}`
  }

  const getDisplayValue = (value: IAutoIdPropertyTypeInterfaces['fullValue'], propertyOptions: IDatabasePropertyResponseInstance<IAutoIdPropertyTypeInterfaces['options']>['options']) => {
    if([null, undefined].includes(value)) {
      return ''
    }
    const prefix = propertyOptions?.prefix || ''
    const suffix = propertyOptions?.suffix || ''
    return `${prefix}${value}${suffix}`
  }

  const compareItemValues = (valueA: unknown, valueB: unknown, sortDirection: DatabaseItemSortDirection): number => {
    if (valueA === null || valueA === undefined) {
      return valueB === null || valueB === undefined ? 0 : 1
    }
    if (valueB === null || valueB === undefined) {
      return -1
    }
    const numA = Number(valueA)
    const numB = Number(valueB)
    const comparison = numA - numB
    return sortDirection === DatabaseItemSortDirection.Ascending ? comparison : -comparison
  }

  const searchToFilterQuery = (search: string, databaseProperties: IDatabasePropertyResponseInstance[]): IFilter => {
    return {
      type: FilterItemType.Group,
      operator: FilterGroupOperator.Or,
      items: databaseProperties.map(databaseProperty => {
        return {
          type: FilterItemType.Property,
          id: databaseProperty.id,
          subProperty: null,
          operator: {
            type: FilterPropertyOperator.Contains,
          },
          payload: {
            type: FilterPropertyPayloadType.Static,
            value: search,
          },
          isDisabled: false,
        }
      }),
    }
  }

  return $$({
    fullValueToText,
    getDisplayValue,
    compareItemValues,
    searchToFilterQuery,
  })
}

